module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('popup-picker', {
    attrs: {
      "fixed-columns": _vm.hideDistrict ? 2 : 0,
      "columns": 3,
      "data": _vm.list,
      "title": _vm.title,
      "show-name": "",
      "inline-desc": _vm.inlineDesc,
      "placeholder": _vm.placeholder,
      "value-text-align": _vm.valueTextAlign,
      "confirm-text": _vm.confirmText,
      "cancel-text": _vm.cancelText,
      "display-format": _vm.displayFormat,
      "popup-style": _vm.popupStyle,
      "show": _vm.showValue
    },
    on: {
      "on-hide": _vm.emitHide,
      "on-show": function($event) {
        _vm.$emit('on-show')
      },
      "update:show": function($event) {
        _vm.showValue = $event
      },
      "on-shadow-change": _vm.onShadowChange
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function(props) {
        return [_vm._t("title", [(props.labelTitle) ? _c('label', {
          class: [props.labelClass, _vm.labelClass],
          style: (props.labelStyle),
          domProps: {
            "innerHTML": _vm._s(props.labelTitle)
          }
        }) : _vm._e()], {
          labelClass: props.labelClass,
          labelStyle: props.labelStyles,
          labelTitle: props.title
        })]
      }
    }]),
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b693534"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/x-address/index.vue
// module id = 635
// module chunks = 1